import { memo } from "react";
import { Div, Tabs, useTheme } from "react-better-html";

type BubbleTabsProps = React.ComponentProps<typeof Tabs> & {
   backgroundColor?: React.CSSProperties["backgroundColor"];
};

function BubbleTabs({ backgroundColor, ...props }: BubbleTabsProps) {
   const theme = useTheme();

   return (
      <Div.box
         width="fit-content"
         backgroundColor={backgroundColor ?? theme.colors.backgroundContent}
         borderRadius={999}
         padding={theme.styles.gap / 2}
      >
         <Tabs style="bubble" accentColor={theme.colors.textPrimary} borderRadius={999} {...props} />
      </Div.box>
   );
}

export default memo(BubbleTabs);
